const STATUS_LABEL: Record<string, string> = {
  PARTICIPATED: "참가",
  CUTOFF: "컷오프",
  DISQUALIFIED: "실격",
  WITHDRAWN: "기권",
  ABSENT: "불참",
};

const STATUS_COLOR: Record<string, string> = {
  PARTICIPATED: "bg-[#F2FFEC] text-[#34C759]",
  CUTOFF: "bg-[#ECF7FF] text-[#007AFF]",
  DISQUALIFIED: "bg-[#FFECEC] text-[#FF3B30]",
  WITHDRAWN: "bg-[#FDF9DA] text-[#A2845E]",
  ABSENT: "bg-[#FAEDFF] text-[#AF52DE]",
};

export default function ParticipantStatusBadge({
  status,
}: {
  status?: string;
}) {
  if (!status) return null;
  const label = STATUS_LABEL[status] ?? status;
  const color = STATUS_COLOR[status] ?? "bg-gray-100 text-gray-600";
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-[5px] text-sm font-semibold whitespace-nowrap ${color}`}
    >
      {label}
    </span>
  );
}
